<template>
  <article class="garage-sidebar">
    <div
      v-if="garage?.onlineBooking && garagePremium"
      class="garage-sidebar__button-wrapper"
    >
      <NuxtLink
        :to="route.path + (garageOtherServiceAvailability?.available ? '/services?other-reason=true' : '/services')"
        class="garage-sidebar__service-button"
      >
        <DmButton
          has-icon="left"
          icon="i-calendar"
          title="Umów wizytę"
        />
      </NuxtLink>
    </div>

    <GarageCalendarRequest
      v-else
      :id="Tabs.Services"
      class="garage-wrapper__section"
      @show-calendar-request-modal="emits('show-calendar-request-modal')"
    />
    <div class="garage-sidebar__wrapper">
      <div
        v-if="!!garageWorkTime"
        class="d-flex-no-wrap align-items-center"
      >
        <NuxtImg
          src="/_nuxt/clock.svg"
          width="20px"
          height="20px"
          class="mr-3"
          alt="Godziny otwarcia"
        />
        <div :class="{ 'garage-sidebar__opening-today--vacation': !!garageVacationInfo?.vacation?.from }">
          {{ openTo }}
        </div>

      </div>

      <div
        v-if="!!garageWorkTime"
        class="d-flex-no-wrap align-items-center"
      >
        <NuxtImg
          src="/_nuxt/paymentMethod.svg"
          width="20px"
          height="20px"
          class="mr-3"
          alt="Metody płatności"
        />
        <div class="d-flex">
          <div v-if="!!garage?.paymentWithCash">Gotówka</div>
          <div v-if="!!garage?.paymentWithCreditCard">/ Karta</div>
        </div>
      </div>

      <div
        v-if="!!garage"
        class="d-flex-no-wrap align-items-center"
      >
        <NuxtImg
          src="/_nuxt/telephone.svg"
          width="20px"
          height="20px"
          class="mr-3"
          alt="Adres serwisu"
        />
        <div class="garage-sidebar__phone-virtual">
          <span>{{ phoneVirtual }}</span>
          <a
            class="garage-sidebar__phone-virtual-link"
            @click="modals.phone = true"
            role="button"
          >Pokaż numer telefonu</a>
        </div>
      </div>
    </div>
  </article>
  <GaragePhoneModal
    v-if="!!garage && modals.phone"
    :modals="modals"
    :phone-number="garage?.phone"
    :garagePremium="garagePremium"
    :suggestedGarages="suggestedGarages"
    :garageVirtualPhones="garageVirtualPhones"
    :garage="garage"
  />
</template>

<script setup lang="ts">
import { DmButton } from '@dobrymechanik/vue-ui-v2';
import type { GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead, GarageVacationJsonldVacationRead, GarageVirtualPhoneNumberJsonldVirtualPhoneRead, GarageWorkTimeJsonldWorkTimeRead, RankingJsonldSuggestedGarageReadRankingRead } from '~/api/docs/api';
import dayjs from 'dayjs';
import { dayNumberToString } from '@/helpers/dayjs';
import { Tabs } from '~/models/enums';
import type { GarageAutobookingServiceStatus } from '~/api/docs/app';

interface IProps {
  garage?: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  garageWorkTime?: GarageWorkTimeJsonldWorkTimeRead;
  garagePriceListCount: number;
  garagePremium: boolean;
  suggestedGarages?: RankingJsonldSuggestedGarageReadRankingRead[];
  garageVirtualPhones: GarageVirtualPhoneNumberJsonldVirtualPhoneRead[];
  garageOtherServiceAvailability: GarageAutobookingServiceStatus;
  garageVacationInfo?: GarageVacationJsonldVacationRead;
}

interface IEmits {
  (name: 'show-calendar-request-modal'): void;
}

//
const emits = defineEmits<IEmits>();

// props
const props = defineProps<IProps>();

// use 
const route = useRoute();

// data
const modals = ref({
  phone: false
});

// computed
const openTo = computed(() => {
  const day = dayNumberToString(dayjs().get('day'));
  const openHours = props.garageWorkTime?.[`${day}`];

  if (props.garageVacationInfo?.vacation?.from) {
    return 'Zamknięte z powodu urlopu';
  }

  return !!openHours?.open ? `Dziś otwarte do ${openHours.to}` : `Dziś zamknięte`;
});

const phoneVirtual = computed(() => {
  const phone = !!props.garageVirtualPhones?.length ? props.garageVirtualPhones[0].phoneVirtual : props.garage?.phone;
  return `${phone?.substring(0, 6)}... `;
});

</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-sidebar.scss');
</style>